module.exports = __webpack_public_path__ + "static/media/Icon_Deliveree_White.f88ca9bf.svg";